import { useNavigate } from "react-router-dom";
import { Icon, StampLogo } from "../components/ui/index.js";

export function WelcomeScreen() {
  const nav = useNavigate();

  return (
    <div className="app-shell">
      <div
        className="screen pad-lg"
        style={{
          textAlign: "center",
          padding: "24px 24px 32px",
          justifyContent: "space-between",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 20,
          }}
        >
          <div style={{ position: "relative" }}>
            <StampLogo size={120} />
            <div
              style={{
                position: "absolute",
                bottom: -8,
                right: -8,
                background: "#fff",
                borderRadius: "50%",
                padding: 6,
                border: "2px solid #fff",
                boxShadow: "0 4px 12px rgba(0,0,0,.12)",
              }}
            >
              <div
                style={{
                  background: "var(--mnp-teal-600)",
                  color: "#fff",
                  borderRadius: "50%",
                  width: 36,
                  height: 36,
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <Icon name="plane" size={20} />
              </div>
            </div>
          </div>
          <div>
            <h1 className="t-h1" style={{ fontSize: 28, marginBottom: 10 }}>
              Посылки из России
              <br />в Грузию
            </h1>
            <p className="t-body" style={{ fontSize: 15, maxWidth: 280, margin: "0 auto" }}>
              Заказывайте на Ozon, Wildberries и других маркетплейсах — <br />
              мы заберём с ПВЗ и привезём в Тбилиси.
            </p>
          </div>
          <div className="flex gap-2 mt-2" style={{ flexWrap: "wrap", justifyContent: "center" }}>
            <span className="badge badge-brand">
              <Icon name="clock" size={12} /> 2–3 дня
            </span>
            <span className="badge badge-brand">от 30 GEL</span>
            <span className="badge badge-brand">Оплата при получении</span>
          </div>
        </div>
        <button
          className="btn btn-primary btn-lg btn-block mt-4"
          onClick={() => nav("/onboarding")}
        >
          Начать <Icon name="arrowRight" size={18} />
        </button>
      </div>
    </div>
  );
}
